goog.provide('el8.appshared.dialog.inviteToPassport');

goog.require('el8.appshared.dialog.confirmPassportRegistration');
goog.require('el8.data.base');
goog.require('el8.data.currUser');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.patients');
goog.require('el8.ptdata.ptRefpanelGrant');
goog.require('el8.ptdata.ptRegistrationInfo');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.refpanel.ptRegistrationInfo');
goog.require('el8.template.appshared.dialog.inviteToPassport');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.base');
goog.require('el8.util.consts');
goog.require('el8.util.validate');
goog.require('el8.appchart.dialog.disablePatientPassport');


// TODO: for practice home, cannot use el8.ptdata.ptRegistrationInfo
el8.appshared.dialog.inviteToPassport = (function() {

    var patientId = null;
    var successCb = null;
    var dismissCb = null;
    var disablePassportCb = null;
    var isFromLetter = false;

    var that = new el8.uiwidget.FormDialog({
        title: 'Patient Passport',
        width: 500,
        position: 'center',
        autoHeight: true,
        contentFn: function() {
            return el8.template.appshared.dialog.inviteToPassport.form({
                phoneTypes: el8.data.phoneTypes
            });
        }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'email',
                selector: ':input[name="email"]',
                infoText: 'email address which will be invited...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                maxLength: 75,
                validate: {
                    required: true,
                    email: true
                }
            },
            {
                name: 'phone1',
                selector: ':input[name="phone1"]',
                infoText: 'e.g. 555-555-5555',
                maxLength: 20,
                validate: { phone: true }
            },
            {
                name: 'phone1Type',
                selector: ':input[name="phone1Type"]'
            },
            {
                name: 'phone2',
                selector: ':input[name="phone2"]',
                infoText: 'e.g. 555-555-5555',
                maxLength: 20,
                validate: { phone: true }
            },
            {
                name: 'phone2Type',
                selector: ':input[name="phone2Type"]'
            },
            {
                name: 'passportPhone',
                selector: ':input[name="phone"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                validate: { required: true }
            },
            {
                name: 'lhsPrefs',
                selector: ':input[name="lhsPrefs"]'
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addButton('send-close', 'Send Invitation & Close', saveFn, true);
    form.addButton('resend-invite', 'Re-send invitation', showInviteForm, true);
    form.addButton('save-lhs-settings', 'Save Settings Changes & Close', function() {
        saveLhsOnly(true);
    });
    form.addButton('close', 'Dismiss', function() {
        if (dismissCb) { dismissCb(); }
        that.hide();
    }, false);

    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        bindTriggers();
        if (!el8.data.currUser.isPhysician()) { form.removeButton('save-lhs-settings'); }
    };

    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};
        super_show.call(that);

        patientId = opts.patientId || el8Globals.PATIENT_ID;
        successCb = opts.successCb;
        dismissCb = opts.dismissCb;
        disablePassportCb = opts.disablePassportCb;
        isFromLetter = opts.fromLetter;
        var patient = el8.ptdata.patients.getById(patientId);

        $('.patient-invite-status', that.getContentElt()).replaceWith(
            el8.template.appshared.dialog.inviteToPassport.inviteStatusDiv({
                patient: patient.asSoyMap(),
                ptRegistrationInfo: el8.ptdata.ptRegistrationInfo.asSoyMap()
            })
        );
        var $detailsTrigger = $('.details-trigger', that.getContentElt());
        if ($detailsTrigger.length) {
            el8.uiwidget.collapsible({
                container: $('.patient-invite-details', that.getContentElt()),
                triggerElt: $detailsTrigger,
                statusElt: $detailsTrigger,
                statusTextCollapse: 'details',
                statusTextExpand: 'less',
                expandFn: function() { that.adjustHeight(); },
                collapseFn: function() { that.adjustHeight(); },
                isCollapsed: true
            });
        }

        // if the ptRefpanelGrant has never been populated, load synchronously
        el8.ptdata.ptRefpanelGrant.softLoad();

        if (el8.ptdata.ptRegistrationInfo.getInviteStatus() === 'NOT_INVITED') {
            showInviteForm();
        } else {
            showInviteDetails();
        }
        form.setVal('lhsPrefs', el8.ptdata.ptRefpanelGrant.getGrantLevel());

        if (!el8.data.currUser.isPhysician()) { form.disableField('lhsPrefs'); }

        // show control to disable patient passport if patient is an active user
        if (el8.ptdata.ptRegistrationInfo.isPatientUser() && !el8.ptdata.ptRegistrationInfo.isPatientUserDisabled()) {
            $('.disablePatientPassportContainer', that.getContentElt()).html(
                el8.template.appshared.dialog.inviteToPassport.disablePatientPassport()
            );
            that.adjustHeight();
        }

    };
    /**
     * Calls show() only if the patient hasn't already been invited. Otherwise,
     * it immediately calls the callback handed to the dialog and returns.
     */
    that.showAsNeeded = function(opts) {
        opts = opts || {};
        if (el8.ptdata.ptRegistrationInfo.getInviteStatus() !== 'NOT_INVITED') {
            if (opts.successCb) { opts.successCb(); }
            return;
        }
        that.show(opts);
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        $('.edit-phone-nums-section', that.getContentElt()).hide();
        $('.email-duplicate-alert', that.getContentElt()).empty();
        patientId = null;
        successCb = null;
        dismissCb = null;
        disablePassportCb = null;
        isFromLetter = false;
    };

    /* Externally callable so that it can embedded in demographics in the future */
    that.updatePhoneDropdown = function(_form, newPhoneEntry) {
        var phone1Type = _form.getVal('phone1Type');
        var phone2Type = _form.getVal('phone2Type');

        $('.which-phone-dropdown', _form.getFormElt()).html(
            el8.template.appshared.dialog.inviteToPassport.patientPhones({
                phone1: _form.getVal('phone1'),
                phone2: _form.getVal('phone2'),
                phone1Type: phone1Type,
                phone2Type: phone2Type,
                newPhoneEntry: newPhoneEntry
            })
        );

        if (phone1Type === 'Cell Phone') {
            _form.setVal('passportPhone', 'phone1');
        } else if (phone2Type === 'Cell Phone') {
            _form.setVal('passportPhone', 'phone2');
        } else {
            // No available passport phones, set to default value of new
            _form.setVal('passportPhone', 'new');
        }
    };

    function refreshRefboardPortalSection() {
        // update passport status in the LHS - won't do anything if on apphome
	    $('#refboard-portal-section').html(
	        el8.template.appchart.refpanel.ptRegistrationInfo.content(
	            el8.ptdata.ptRegistrationInfo.asSoyMap()
	        )
	    );
    }

    /* Internal Functions */
    function bindTriggers() {
        var $content = that.getContentElt();
        var _updateDropdown = function() { that.updatePhoneDropdown(form, true); };
        // if any of the phone number fields change, update the dropdown
        $content.on('change', ':input[name="phone1"]',  _updateDropdown)
            .on('change', ':input[name="phone2"]',  _updateDropdown)
            .on('change', ':input[name="phone1Type"]',  _updateDropdown)
            .on('change', ':input[name="phone2Type"]',  _updateDropdown);

        $content.on('change', ':input[name="passportPhone"]',  function() {
            if (form.getVal('passportPhone') === 'new') {
                $('.edit-phone-nums-section', $content).show();
                that.adjustPosition();
            }
        });

        // users often paste in emails with extra whitespace
        $content.on('change', ':input[name="email"]',  function() {
            form.setVal('email', form.getVal('email').trim(), true);
        });

        $content.on('click', '.patient-passport-account-disable',  function() {
            el8.appchart.dialog.disablePatientPassport.show({
                successCb: function() {
                    el8.ptdata.ptRegistrationInfo.setPatientUserDisabled(true);
                    refreshRefboardPortalSection();
                    if (disablePassportCb) {
                        disablePassportCb();
                    }
                    that.hide();
                }
            });
        });
    }

    /**
     * Used when the patient is being invited - reveals a form to pick email/phone before inviting
     */
    function showInviteForm() {
        $('.passport-invite-form', that.getContentElt()).show();
        form.hideButton('resend-invite');
        form.hideButton('save-lhs-settings');
        form.showButton('send-close');

        var patient = el8.ptdata.patients.getById(patientId);
        form.setVal('email', patient.getEmail());
        form.setVal('phone1', patient.getPhone1(), true); // avoid change events - we'll updatePhoneDropdown ourselves
        form.setVal('phone2', patient.getPhone2(), true);

        // Default both phone1Type and phone2Type to "Mobile" not currently set
        // to a  valid option; Mobile is the first item in Phone Types array.
        // Both inputs should be mobile because Home phones are invalid for Passport
        // invitation
        var phone1Type = patient.getPhone1Type();
        var phone1TypeValue = phoneTypeExists(phone1Type) ? phone1Type :  el8.data.phoneTypes[0];
        form.setVal('phone1Type', phone1TypeValue, true);


        var phone2Type = patient.getPhone2Type();
        var phone2TypeValue = phoneTypeExists(phone2Type) ? phone2Type :  el8.data.phoneTypes[0];
        form.setVal('phone2Type', phone2TypeValue, true);

        if (!patient.getPhone1() && !patient.getPhone2()) { // there are no existing phone nums to select
            $('.edit-phone-nums-section', that.getContentElt()).show();
        }

        that.updatePhoneDropdown(form, true);
        that.adjustPosition();

        form.focusField('email');
    }
    /**
     * Used when the patient has already been invited - shows details about when the patient
     * was invited and whether they've registered. If they haven't registered, the user
     * can click "Resend Invite" to switch to the mode above
     */
    function showInviteDetails() {
        $('.passport-invite-form', that.getContentElt()).hide();
        form.hideButton('send-close');
        form.showButton('save-lhs-settings');
        if (el8.ptdata.ptRegistrationInfo.getInviteStatus() === 'USED') {
            form.hideButton('resend-invite');
            form.getButtonSet().makeButtonPrimary('save-lhs-settings');
        } else {
            form.showButton('resend-invite');
        }
        that.adjustPosition();
    }

    function saveFn() {
        if (!validate()) { return; }
        form.disable();
        var mapped = form.getMapped(false, true); // leave in blank values; under_score_keys
        var $demogSection = $('.edit-phone-nums-section', that.getContentElt());
        if (!$demogSection.is(':visible')) { // only send up these keys if they were being edited
            delete mapped['phone1'];
            delete mapped['phone2'];
            delete mapped['phone1_type'];
            delete mapped['phone1_type'];
        }
        delete mapped['lhs_prefs'];
        // patients invited while being sent a letter don't need a welcome letter
        mapped['welcome_letter'] = !isFromLetter;

        saveLhsOnly(false);

        $.el8_ajax({
            url: el8.service.urls.get('invitePatient'),
            type: 'POST',
            data: JSON.stringify(mapped),
            success: function(data) {
                el8.ptdata.ptRegistrationInfo.populate(data);
                refreshRefboardPortalSection();
                el8.ptdata.patients.refreshById(patientId); // demographics may have changed
                el8.ptdata.currPatient = el8.ptdata.patients.getById(patientId);

                el8.appshared.dialog.confirmPassportRegistration.show(patientId, isFromLetter);

                // If this is the first time we've POSTED with welcome_letter=true,
                // a welcome letter should have just been created - make it show in the chartFeed
                if (mapped['welcome_letter']) {
                    el8.ptdata.letters.trigger(EVENTS.CREATED); // listener bound in mainFeeds.js
                }

                if (successCb) { successCb(); }
                form.enable();
                that.hide();
            },
            error_override: function(data) {
                //409 = "conflict" and we use it here to represent a duplicate email
                if (data.status === 409) {
                    $('.email-duplicate-alert', that.getContentElt()).html(
                        el8.template.appshared.dialog.inviteToPassport.emailDuplicateAlert()
                    );
                    that.adjustHeight();
                } else if (data.status === 400) {
                    // 400 is returned when patient can't be invited for some reason
                    el8.uiwidget.alert(data.responseText);
                } else {
                    el8.uiwidget.alert('Sorry! The patient could not be invited. '+
                        'Please try again, or contact support if this issue persists.');
                }
                form.enable();
            }
        });
    }

    function saveLhsOnly(doHide) {
        var grantLevel = form.getVal('lhsPrefs');
        $.el8_ajax({
            url: el8.service.urls.get('patientLhsSettings'),
            type: 'POST',
            data: JSON.stringify({ granted_refpanel: grantLevel }),
            success: function() {
                el8.ptdata.ptRefpanelGrant.setGrantLevel(grantLevel);
                if (doHide) { that.hide(); }
            }
        });
    }

    function validate() {
        if (!form.isValid()) {
            el8.uiwidget.alert('Please double check the field outlined in red to continue.');
            return false;
        }
        if (form.getVal('passportPhone') === 'new') {
            el8.uiwidget.alert('Please select a cell phone number for the patient.');
            return false;
        }
        var passportPhoneType = form.getInputField('passportPhone').find(':selected').attr('data-type');
        if (passportPhoneType !== 'Cell Phone') {
            el8.uiwidget.alert('The phone number for passport must be a cell phone. ' +
                'If the existing number is a valid cell phone, please change the phone type to "Mobile."');
            return false;
        }
        return true;
    }

    function phoneTypeExists(type) {
        return _.some(el8.data.phoneTypes, function(typeDefinition) {
            var typeValue = typeDefinition[0];
            return type === typeValue;
        });
    }

    return that;

})();
